import { Checkbox } from "@/components/ui/checkbox";
import {
  CellProps,
  isBooleanControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";

export const BooleanCell = (props: CellProps) => {
  const { data, id, enabled, path, handleChange } = props;

  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        checked={!!data}
        onCheckedChange={(checked) =>
          handleChange(path, checked ? true : false)
        }
        id={id}
        disabled={!enabled}
        aria-describedby={`${id}-description`}
      />
    </div>
  );
};

export const booleanCellTester: RankedTester = rankWith(4, isBooleanControl);

export default withJsonFormsCellProps(BooleanCell);
